import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.rokwansoft.com';

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Sets document title, meta description, canonical link, and OG/Twitter
// tags per route. Runs client-side (no SSR in this app) but keeps the
// crawled <head> in sync once JS executes, and covers the many crawlers
// that do render JS.
export const useSeo = (titleKey, descriptionKey) => {
  const { t } = useTranslation();
  useSeoText(t(titleKey), t(descriptionKey));
};

export const useSeoText = (rawTitle, description) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = `${rawTitle} | Rokwansoft`;
    const url = `${SITE_URL}${pathname}`;

    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'twitter:title', title);
    setMeta('property', 'twitter:description', description);
    setMeta('property', 'twitter:url', url);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    return () => {
      document.title = 'Rokwansoft';
    };
  }, [rawTitle, description, pathname]);
};
